export enum SectionActionTypeEnums {
    ADD =               0,  // -> 0
    ADD_MACHINE_ROOM =  1,  // -> 1
}
